import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericService } from '../generic.service';

@Injectable({
  providedIn: 'root'
})
export class GenericActivityService {

  baseurl = environment.baseUrl;
  constructor(private apiService: GenericService) {}


  getAllList(companyId?:any) {
    return this.apiService.Get<any[]>(`risk-assisment/get-generic-activity-list?companyId=${companyId}`);
  }

  vesselHistory() {
    return this.apiService.Get<any[]>(`risk-assisment/get-specific-vessel-history`);
  }
  vesselHistoryById(id:any) {
       return this.apiService.Get<any[]>(`risk-assisment/get-specific-vessel-history?`+id);
  }
}
